// Pure label/format helpers shared across the Move V2 step views.
export var containerLabel = function (c) {
    if (!c)
        return '';
    var kind = c.isPallet ? 'Pallet' : 'Carton';
    return kind + " " + (c.serialNumber || c.containerId);
};
export var matchLabel = function (m) {
    if (m.matchType === 'container')
        return containerLabel(m.container);
    if (m.matchType === 'asset')
        return "Asset " + m.assetId + " \u00B7 " + (m.productSku || m.productName || m.productId);
    return (m.productSku || m.productId) + " \u00B7 " + (m.productName || '');
};
export var holdingLabel = function (h, t) {
    var _a;
    return h.containerId
        ? (((_a = h.containerTypeEnumId) === null || _a === void 0 ? void 0 : _a.startsWith('CtPallet')) ? t('Pallet') : t('Carton')) + " " + (h.serialNumber || h.containerId) + " \u00B7 " + t('Qty') + " " + h.quantityOnHand
        : t('Loose (no container)') + " \u00B7 " + t('Qty') + " " + h.quantityOnHand;
};
export var formatDate = function (d) {
    if (!d)
        return '';
    try {
        return new Date(d).toISOString().slice(0, 10);
    }
    catch (_a) {
        return String(d);
    }
};
export var lotLabel = function (l, t) {
    var parts = [l.lotNumber || l.lotId || t('No lot'), t('Qty') + " " + l.quantity];
    if (l.expirationDate)
        parts.push(t('Exp') + " " + formatDate(l.expirationDate));
    if (l.expired)
        parts.push(t('EXPIRED'));
    return parts.join(' · ');
};
